import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["name", "value"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["checked", "onChange"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]

import {
    type PropType,
    computed,
    getCurrentInstance,
    nextTick,
    onMounted,
    ref,
    watch,
} from "vue";
import CoolRadio from "../../shared/CoolRadio.vue";
import labels from "../../shared/labels";
import { type SortingOptionItem } from "./types";


export default /*@__PURE__*/_defineComponent({
  __name: 'sorting',
  props: {
    options: {
        type: Array as PropType<SortingOptionItem[]>,
        required: true,
    },
    sortingOptionName: String,
    value: String,
},
  emits: ["input", "submitForm"],
  setup(__props, { emit: __emit }) {

const props = __props;

const mobile = ref(!document.body.classList.contains("desktop"));
const openMenu = ref(false);

const currentOption = computed(() => {
    return props.options.find((opt) => opt.value === props.value);
});
// const currentOptionText = computed(() => {
//     const currOption = currentOption.value;
//     if (currOption != null) return currOption.text;
//     return labels.frontendProductList.filters.sorting.sortValueEmpty;
// });

watch(
    () => props.value,
    () => {
        nextTick(function () {
            submitForm();
        });
    }
);
const emit = __emit;
function emitValue(v: string) {
    //console.log("EMIT SORTING: "+value);
    emit("input", v);
}
function selectOption(option: SortingOptionItem) {
    emitValue(option.value);
    openMenu.value = false;
}

const hiddenValue = ref<HTMLInputElement>();

function submitForm() {
    emit("submitForm");
}

const option = props.options.find((x) => x.selected);
if (option != null) emitValue(option.value);

const instance = getCurrentInstance();

const placeholderElement = ref<HTMLElement | undefined | null>(undefined);
const placeholderExists = computed(() => {
    if (placeholderElement.value === undefined) return undefined;
    return placeholderElement.value != null;
});
const moved = ref(false);

function getPlaceholderElement() {
    return document.querySelector<HTMLElement>(".sorting-placeholder");
}

function checkForPlaceholderElement(source: string) {
    if (mobile.value) {
        console.debug(
            "sorting-placeholder: cancel: mobile. no placeholder needed"
        );
        return;
    }
    if (placeholderElement.value != null) {
        console.debug("sorting-placeholder: cancel: already have placeholder");
        return;
    }
    placeholderElement.value = getPlaceholderElement();
    console.debug(
        "sorting-placeholder: " +
            (placeholderElement.value ? "got placeholder" : "no placeholder") +
            " from " +
            source
    );
}

//checkForPlaceholderElement();

if (placeholderElement.value == null) {
    document.addEventListener("DOMContentLoaded", () => {
        checkForPlaceholderElement("DOMContentLoaded");
    });
}

function tryMoveToPlaceholder(container: HTMLElement) {
    console.debug("try move placeholder");
    if (instance?.proxy == null) return false;
    if (moved.value) return true;
    // const container = document.querySelector(".sorting-placeholder");
    if (container == null) return false;
    container.appendChild(instance.proxy.$el);
    moved.value = true;
    return true;
}

// watch(
//     () => mobile.value || placeholderExists.value == false || moved.value,
//     (newValue) => {
//         console.log("v-show", newValue, {
//             mobile: mobile.value,
//             placeholderExists: placeholderExists.value,
//             moved: moved.value,
//         });
//     },
//     {
//         immediate: true,
//     }
// );

onMounted(() => {
    if (!mobile.value) {
        checkForPlaceholderElement("onMounted");
        if (
            placeholderElement.value == null ||
            !tryMoveToPlaceholder(placeholderElement.value)
        ) {
            //console.warn("doc",document.readyState);
            // document.addEventListener("readystatechange", function (ev) {
            //     console.debug("doc", document.readyState);
            // });
            document.addEventListener("DOMContentLoaded", () => {
                if (placeholderElement.value)
                    tryMoveToPlaceholder(placeholderElement.value);
            });
        }
    }
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['sorting-component']),
    "data-sorting-component": ""
  }, [
    _createElementVNode("input", {
      type: "hidden",
      name: __props.sortingOptionName,
      value: __props.value,
      form: "productListFilterForm",
      ref_key: "hiddenValue",
      ref: hiddenValue
    }, null, 8 /* PROPS */, _hoisted_1),
    (!mobile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style['sort-header'])
          }, _toDisplayString(_unref(labels).frontendProductList.filters.sorting.sortHeader), 3 /* TEXT, CLASS */),
          _createCommentVNode("<span :class=\"$style['current-sorting']\" @click=\"openMenu = true\">{{currentOptionText}}</span>"),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['sorting-checkbox-list'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                        _ctx.$style['sorting-checkbox-list-item'],
                        currentOption.value === option ? _ctx.$style['active'] : '',
                    ])
              }, [
                _createCommentVNode("<div :class=\"$style['sorting-item-spacer']\" v-if=\"options.indexOf(option) > 0\"></div>"),
                _createElementVNode("label", null, [
                  _createVNode(CoolRadio, null, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "radio",
                        checked: currentOption.value === option,
                        onChange: ($event: any) => (selectOption(option))
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)
                    ], undefined, true),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createTextVNode(" " + _toDisplayString(option.text), 1 /* TEXT */)
                ])
              ], 2 /* CLASS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 2 /* CLASS */),
          _createCommentVNode("<div v-if=\"openMenu\" :class=\"$style['sorting-menu']\">\r\n                <div :class=\"$style['blur-overlay']\" @click=\"openMenu = false\"></div>\r\n                <template v-for=\"option in options\">\r\n                    <div :class=\"$style['sorting-item-spacer']\" v-if=\"options.indexOf(option) > 0\"></div>\r\n                    <div>\r\n                        <span :class=\"[$style['sorting-item'], currentOption === option ? $style['selected'] : '']\" @click=\"selectOption(option)\">{{option.text}}</span>\r\n                    </div>\r\n                </template>\r\n            </div>")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['sorting-items'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                                _ctx.$style['sorting-item'],
                                currentOption.value === option
                                    ? _ctx.$style['selected']
                                    : '',
                            ]),
                    onClick: ($event: any) => (selectOption(option))
                  }, _toDisplayString(option.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style['sorting-item-spacer'])
                }, null, 2 /* CLASS */)
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ]))
  ], 2 /* CLASS */)), [
    [_vShow, mobile.value || moved.value || placeholderExists.value != null]
  ])
}
}

})